import { memo } from 'react'
import { useI18n } from '@muse/i18n'
import { Logo } from '../components/logo'
import { ROUTES } from '../constants/routes'

export const LogoContainer = memo(() => {
    const { t } = useI18n()

    return <Logo href={ROUTES.home} label={t('i18n.headerHome')} />
})
